import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent {
  showPassword = false;
  logo = './assets/' + environment.projectName + '/media/header/logo.png';
  lang: string = '';
  email: string = ''; 

  user: any = {
    userId: JSON.parse(localStorage.getItem('userInfo') || '{}').userId,
    sub: '',

  };

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router
  ) {
    this.route.params.subscribe((params) => {
      if (params) {
        this.lang = params['lang'];
      }
    });
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras?.state as { email: string };
    if (state?.email) {
      this.email = state.email;
    }
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }



  resetPassword() {


    const payload = {
      ...this.user,
      email: this.email,
    };

    this.authService.resetPassword(payload).subscribe(
      (response: any) => {
        localStorage.setItem('accessToken', response.accessToken);
        this.router.navigate(['/' + this.lang + '/login']); 
      },
      (error: any) => {
        alert('Error resetting password');
      }
    );
  }
}